module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Ab3"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "JANUARY 9: Our Infinite God"
    }
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "pAXl"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#AB_ch10",
      "id": "AB_cha10"
    }
  }, [_vm._v("JANUARY 9"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "chapter2"
  }, [_vm._v("Our Infinite God")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "pArvi"
    }
  }, [_c('em', [_vm._v("Oh, the depth of the riches both of the wisdom and knowledge of God! How unsearchable are His judgments and His ways past finding out!")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pAFU3"
    }
  }, [_vm._v("—Romans 11:33")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "ADz"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("T")])]), _vm._v("he saying “The bigger, the better” is not always true. We don’t necessarily need a larger house, and a more robust dinner may not be healthy. A longer to-do list? No, thank you! An increased mortgage? That’s going the wrong direction. But a big God—a God far greater than the very limited version we tend to carry around in our heads and hearts—would indeed be better.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAelj"
    }
  }, [_vm._v("We can thank our all-encompassing God, for instance, that His wisdom far surpasses ours. We can be grateful that His ways aren’t our ways, that His thoughts aren’t our thoughts, that His judgments are righteous beyond our understanding, and even that His decisions can be puzzling and His timing perplexing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAops"
    }
  }, [_vm._v("If we human beings—with our limited brainpower—could fully understand the whys and hows of God’s ways, thoughts, judgments, decisions, and timing, our God would be pretty limited. Isn’t that an unsettling thought? Aren’t you glad to know you will never (this side of heaven) completely grasp your infinite God in all His glory, power, wisdom, and truth?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAYc6"
    }
  }, [_vm._v("Bigger isn’t always better—unless it’s the God of heaven we’re talking about!")]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pA8k1"
    }
  }, [_c('em', [_vm._v("Thank You, Lord, for being beyond what my reason can fathom.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6284774","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter10.vue
// module id = 96
// module chunks = 0